import { create } from 'zustand';

interface ToastState { msg: string | null; show: (m: string) => void }
let timer: ReturnType<typeof setTimeout> | undefined;

export const useToast = create<ToastState>((set) => ({
  msg: null,
  show: (msg) => { set({ msg }); clearTimeout(timer); timer = setTimeout(() => set({ msg: null }), 1800); },
}));

export const toast = (m: string) => useToast.getState().show(m);
